import { client as clientRoutes } from 'config/routes'

//TODO: TM-1346 will update this to use values expected from API
export const GOUSTO_ANYTIME_INTENT_URLS: Record<string, string> = {
  start_one_off_order: clientRoutes.menu,
  reactivate_subscription: clientRoutes.mySubscription,
}

export const getUrlForGoustoAnytimeIntent = (intent: string): string | undefined =>
  GOUSTO_ANYTIME_INTENT_URLS[intent]
